export const jobDetailParser = (jobOffer, jobId) => { 
    if (!jobOffer || !jobOffer.restaurant) return null;
  
    const benefits = Array.isArray(jobOffer.restaurant.benefits) ? jobOffer.restaurant.benefits : [];
   
    return {
      headerData: {
        name: jobOffer.restaurant.name || 'Desconocido',
        companyType: jobOffer.restaurant.format || 'N/A',
        position: jobOffer.position || 'No especificado',
        imageUrl: jobOffer.restaurant.profileImageUrl || 'No hay foto',
        applicationId: jobId
      },
      informationData: {
        establecimiento: jobOffer.restaurant.format || 'No especificado',
        ubicación: (() => {
          // If location is null or doesn't have an address, return "No especificado"
          if (!jobOffer.location || !jobOffer.location.address) {
            return 'No especificado';
          }
          const location = jobOffer.location.address;
          if (location === 'No hay') {
            return 'No especificado';
          }
          return location;
        })(),
        postulantes: jobOffer.applicationsCount || 0, 
        oferta_publicada: jobOffer.createdAt || 'No disponible'
      },
      conditionsData: {
        contrato: jobOffer.contract || 'No especificado',
        disponibilidad: jobOffer.schedule || 'No especificado',
        sueldo: jobOffer.salary ? `$${jobOffer.salary.toLocaleString()}` : 'No especificado',
        propinas: jobOffer.tips ? 'Sí' : 'No',
        vacantes: jobOffer.vacancies || 'No especificado'
      },
      description: jobOffer.description || 'No se proporcionó descripción',
      benefits: benefits,
      functions: jobOffer.functions || 'No se listaron funciones',
      requirements: jobOffer.requirements || 'No se listaron requisitos',
      location: jobOffer.location ? [jobOffer.location.address] : [],
      questions: jobOffer.questions || 'No se agregaron preguntas',
      aplicaciones: jobOffer.applicationsCount || 0,
      creado: jobOffer.createdAt,
    };
  };
  